import React from 'react';
import { Button, Card, CardContent, CardHeader, CardTitle } from '@mf-tools/domains-ui';
import { Container } from '../components';

export interface LegalProps {
  title: string;
}

export function Legal({ title }: LegalProps): React.ReactElement {
  return (
    <div>
      <header className="border-b bg-background/80 backdrop-blur">
        <Container className="flex h-16 items-center justify-between">
          <a href="/" className="font-semibold text-foreground">
            OpsPilott
          </a>
          <Button asChild variant="secondary" size="sm">
            <a href="/">Back to home</a>
          </Button>
        </Container>
      </header>
      <main className="py-14">
        <Container>
          <Card>
            <CardHeader>
              <CardTitle>{title}</CardTitle>
            </CardHeader>
            <CardContent className="text-sm text-muted-foreground">
              This is a placeholder page for now.
            </CardContent>
          </Card>
        </Container>
      </main>
    </div>
  );
}

